import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required — becomes both the accessible name and the tooltip. */
  label: string;
  icon: ReactNode;
  active?: boolean;
}

/** Square 40px icon-only control. The label is mandatory so it can never ship unlabelled. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, active = false, className = "", ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      aria-label={label}
      title={label}
      className={`flex size-10 items-center justify-center rounded-lg transition-colors
        ${active ? "bg-accent-50 text-accent-600" : "text-muted-foreground hover:bg-ink-100 hover:text-ink-800"}
        ${className}`}
      {...props}
    >
      {icon}
    </button>
  );
});
